import { RegisterPage } from './RegisterPage'
import { withRegisterPage } from './withRegisterPage'

const ConnectedRegisterPage = withRegisterPage(RegisterPage)

export { ConnectedRegisterPage as RegisterPage }
